"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const hasLocalStorage = function () {
  const str = 'lstest';
  try {
    localStorage.setItem(str, str);
    localStorage.removeItem(str);
    return true;
  } catch (_) {
    return false;
  }
}();
const fontLoader = _ref => {
  let {
    url,
    version,
    name
  } = _ref;
  // for Opera Mini (without WOFF and localStorage support)
  if (!hasLocalStorage) {
    return;
  }
  const head = document.getElementsByTagName('head')[0];
  const KEY_NAME = `${name}Font`;
  const VERSION_KEY_NAME = `${name}FontVersion`;
  function addStyleElement(content) {
    const styleElement = document.createElement('style');
    styleElement.textContent = content;
    head.appendChild(styleElement);
  }
  function getFile(url, callback) {
    const request = new window.XMLHttpRequest();
    request.open('GET', url, true);
    request.onload = function () {
      callback(request.responseText);
    };
    request.send();
  }
  let isVersionCurrent = false;
  let styleText = null;
  try {
    isVersionCurrent = window.localStorage.getItem(VERSION_KEY_NAME) === version;
    styleText = window.localStorage.getItem(KEY_NAME);
  } catch (_) {
    return;
  }
  if (isVersionCurrent && styleText) {
    addStyleElement(styleText);
    return;
  }
  getFile(url, response => {
    try {
      window.localStorage.setItem(KEY_NAME, response);
      window.localStorage.setItem(VERSION_KEY_NAME, version);
    } catch (_) {
      // sometimes localStorage is unavailable, it won't break anything
    } finally {
      addStyleElement(response);
    }
  });
};
var _default = exports.default = fontLoader;
//# sourceMappingURL=index.js.map